var React = require('react');

function Up (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"up_icon","d":"M14.848 19.087L7.314 12.24a1 1 0 0 1 0-1.48l7.534-6.847a1.67 1.67 0 0 1 2.198 0 1.326 1.326 0 0 1 0 1.997l-5.338 4.85a1 1 0 0 0 0 1.48l5.338 4.85a1.325 1.325 0 0 1 0 1.997 1.634 1.634 0 0 1-1.1.413c-.397 0-.795-.137-1.098-.413z"})),React.createElement("use",{"fillRule":"nonzero","transform":"rotate(90 12 11.5)","xlinkHref":"#up_icon","key":1})]);
}

Up.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Up;

Up.default = Up;
